import { colors } from '../../../shared/styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background-color: ${colors.$darkBlue};
    display: flex;
    align-items: center;
    padding-left: 50px;
    padding-right: 50px;
`;
